module.exports = __webpack_public_path__ + "static/img/logo-demi.79208c6d.png";